export default "__VITE_ASSET__Cea9VzXf__"